<template>
  <div class="video-message" v-if="$store.state.videoing">
    <!--<img class="video-message-bg" :src="$cookies.get('avatar')">-->
    <!--<div class="video-bg"></div>-->

    <div class="message-info">
      <div class="doc-info">
        <p>{{$store.state.videodoctor}}</p>
        <span>邀请你进行视频通话</span>
      </div>
      <div class="doctor-head">
        <img src="../../../static/icons/me@2x.png" alt="">
      </div>
    </div>
    <div class="video-btns">
      <div class="video-item">
        <div class="video-btn" @click="closeVideo()">
          <i class="guaduan"></i>
        </div>
        <p>返回</p>
      </div>
      <div class="video-item">
        <wx-open-launch-weapp
          id="launch-btn"
          username="gh_b045f329a5e8"
          :path="'pages/index/index.html?huiid='+$store.state.huiid+'&huanId='+$cookies.get('app_token')+'&group='+$store.state.videoGroup"
        >
          <script type="text/wxtag-template">
            <style>
              .video-btn{
                width: 65px;
                height: 65px;
                margin-bottom: 10px;
                background: none;
                border: none;
                outline: none;
                padding: 0;
              }
              .jieting{
                width: 65px;
                height: 65px;
              }
            </style>
            <div class="video-btn">
              <img src="data:image/png;base64,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" class="jieting">
            </div>
          </script>
        </wx-open-launch-weapp>
        <p>打开小程序</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'videoMessage',
    data(){
      return {

      }
    },
    mounted () {

    },
    methods:{
      closeVideo(){
        this.$store.commit('setVideoing',false);
        setTimeout( ()=>{
          let msgId = WebIM.conn.getUniqueId();
          let msgobj = new WebIM.message("txt", msgId);
          let from = this.$cookies.get('app_token');
          console.log(msgobj)
          var option = {
            msg: '[视频问诊]', // 这儿是发送的消息内容
            to:this.$store.state.videoGroup, // 接收消息对象(聊天室id) this.groupid
            roomType: false,
            chatType: "groupChat",
            from:from,
            // 这儿的ext是自定义属性，安卓端可以根据这个属性获取信息,以name、age为例（与安卓商量着来）
            ext: {
              from: "me",
              videoChatStatus:true,
              statusDesc:2
            },
            type: "groupchat",
            success: (id, res) => {
              let nbody = msgobj.body;
              msgobj.body.body = {
                ext:nbody.ext,
                from:nbody.from,
                msg:nbody.msg,
                to:nbody.to
              };
              this.$store.commit('setVideoing',false);
              console.log(res)
            },
            fail: (res) => {
              console.log('失败',res);
              this.$store.commit('setVideoing',false);
              this.$message.error("信息发送失败");
            },
          };
          msgobj.set(option);
          msgobj.setGroup("groupchat");
          this.$imConn.send(msgobj.body);
        },1000)

      }
    }
  }
</script>

<style scoped>
.video-message{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  /*background: rgba(0,0,0,0.2);*/
  background: #fff;
  color: #666;
  display: block;
  z-index: 99999;
}
.video-message-bg{
  width: 100%;
  height: 100%;
  filter: blur(10px);
  object-fit: cover;
}
.video-bg{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.5);
}
  .message-info{
    display: flex;
    width: 10.5rem;
    float: right;
    align-items: center;
    justify-content: space-between;
    text-align: right;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
  .message-info p{
    font-size: 1.2rem;
    line-height: 1.65rem;
  }
  .message-info span{
    font-size: 0.7rem;
    color: #999;
    line-height: 1rem;
    margin-top: 0.3rem;
  }
  .doctor-head{
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 0.5rem;
    overflow: hidden;
  }
  .doctor-head img{
    width: 100%;
    height: 100%;
  }
  .video-btns{
    width: 100%;
    display: flex;
    padding: 0 3.25rem;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 3rem;
    left: 0;
    font-size: 0.8rem;
    text-align: center;
  }
  .video-btn{
    width: 65px;
    height: 65px;
    margin-bottom: 10px;
  }
  .guaduan{
    content: url("../../../static/icons/back.png");
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/videoMessage/videoMessage.vue